'use client'

import { Avatar } from '~/elements'
import type { User } from '~/features/users/types'
import { useAppStore } from '../../stores'
import { UserDropdown } from './UserDropdown'

export function NavUser() {
  const user = useAppStore((s) => s.currentUser)

  return (
    <UserDropdown disabled={!user} user={user as User} asChild>
      <Avatar
        name={user?.displayName || user?.email}
        pictureUrl={user?.profilePicture}
        className="h-7 w-7 rounded-full hover:cursor-pointer sm:h-8 sm:w-8"
        variant="soft"
      />
    </UserDropdown>
  )
}
